import { endOfMonth, startOfMonth } from '@internationalized/date'
import cx from 'classnames'
import {
  type CalendarProps,
  type DateValue,
  Heading,
} from 'react-aria-components'

import { Stack } from '../../../structure/stack/Stack'
import { typographyStyles } from '../../../structure/typography/styles'
import { CalendarHeaderButton } from './CalendarHeaderButton'

type Props = Pick<CalendarProps<DateValue>, 'minValue' | 'maxValue'> & {
  visibleRange: { start: DateValue; end: DateValue }
}

export const CalendarHeader = ({ minValue, maxValue, visibleRange }: Props) => {
  const isPreviousDisabled =
    !!minValue && visibleRange.start.compare(startOfMonth(minValue)) <= 0
  const isNextDisabled =
    !!maxValue && visibleRange.end.compare(endOfMonth(maxValue)) >= 0
  return (
    <Stack className="items-center">
      <CalendarHeaderButton
        variant="previous"
        isDisabled={isPreviousDisabled}
      />

      <Heading
        aria-hidden={false}
        className={cx(
          typographyStyles({ weight: 'semibold', size: 'lg' }),
          'grow text-center',
        )}
        slot="label"
      >
        {visibleRange.start.year === visibleRange.end.year
          ? String(visibleRange.start.year)
          : `${visibleRange.start.year} - ${visibleRange.end.year}`}
      </Heading>
      <CalendarHeaderButton variant="next" isDisabled={isNextDisabled} />
    </Stack>
  )
}
